import { render, staticRenderFns } from "./GroupSetting.vue?vue&type=template&id=64e0f631&scoped=true"
import script from "./GroupSetting.vue?vue&type=script&lang=js"
export * from "./GroupSetting.vue?vue&type=script&lang=js"
import style0 from "./GroupSetting.vue?vue&type=style&index=0&id=64e0f631&prod&lang=scss&scoped=true"
import style1 from "./GroupSetting.vue?vue&type=style&index=1&id=64e0f631&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e0f631",
  null
  
)

export default component.exports